import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujv35pmww6: FaireProductEntity = {
  token: "p_ujv35pmww6",
  type: "product",
  name: "Birthday Cherries Card",
  brandToken: "b_332kmgihxr",
  brandName: "Ula Bloom",
  imageUrl: "https://cdn.faire.com/fastly/fa98e2aa96b838bb1fa840a9d3fdec0e11be586e95578168fb2b72c76b1f87de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7fa4c291bc859418b92ba2629cdaa55ca16c7bd706d47d5b6843da313d11a3e.jpeg"
  ],
  priceDollars: 3,
  description: "This card provides 1 day of literacy education to a child in need, helping them to dream, grow, and bloom into their full potential.\n\nAll donations are made through the non-profit organization Room to Read.\n\n• Size: A2 4.25” x 5.5”\n• Blank inside\n• Printed on FSC certified paper, made in USA",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:59.287Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
